function toggleCourseDetails( ) {

    $(document).ready(function() {
        $(".js-toggle-course-details-link").click(function() {
            const detailsParagraph = $(this).siblings("p");
            const moreLink = $(this).find(".js-toggle-course-details-link-more");
            const lessLink = $(this).find(".js-toggle-course-details-link-less");
      
            if (detailsParagraph.is(":hidden")) {
                detailsParagraph.slideDown();
                moreLink.hide();
                lessLink.show();
            } else {
                detailsParagraph.slideUp();
                moreLink.show();
                lessLink.hide();
            }
        });
    });

}

export { toggleCourseDetails };